import {Badge} from 'react-bootstrap'
import {defineMessages, useIntl, MessageDescriptor} from 'react-intl'

const COLORS: Record<string, string> = {
  APPROVED: 'success',
  PENDING: 'warning',
  NOT_ASSIGNED: 'danger',
  CANCELED: 'secondary',
}

const LABELS: Record<string, MessageDescriptor> = defineMessages({
  APPROVED: {id: 'commissions.detail.status.approved', defaultMessage: 'Approved'},
  PENDING: {id: 'commissions.detail.status.pending', defaultMessage: 'Pending'},
  NOT_ASSIGNED: {id: 'commissions.detail.status.notAssigned', defaultMessage: 'Not assigned'},
  CANCELED: {id: 'commissions.detail.status.canceled', defaultMessage: 'Canceled'},
})

export const BadgeStatus = ({state}: {state: string}) => {
  const intl = useIntl()
  const label = LABELS[state] ? intl.formatMessage(LABELS[state]) : state
  return <Badge bg={COLORS[state]}>{label}</Badge>
}
